/*
 * Authors: mariushirjanu
 * Created: 20/08/2018
 * Upgraded: 29/11/2022
 */
import { HttpDataService } from '../http/http-data.service';

import { IQuestion } from '../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';

@Injectable()
export class SurveyDataService {
  public static WORKFLOW_BP:string = 'BP';
  public static WORKFLOW_COUNTRY:string = 'COUNTRY';
  public static WORKFLOW_OEM_COUNTRY:string = 'OEM_CNTRY';

  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getSurveyQuestions(countryId:number, workflowType:string, companyId?:number):Promise<IQuestion[]> {
    return this.httpDataService.doGET(
      'rest/questions',
      {
        countryId,
        companyId,
        keyword: 'SURVEY',
        workflowType
      },
      undefined,
      'Error loading survey questions'
    );
  }
}